import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _19a2bbf6 = () => interopDefault(import('../pages/countries.vue' /* webpackChunkName: "pages/countries" */))
const _2115ca00 = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _e701308c = () => interopDefault(import('../pages/no-subscription.vue' /* webpackChunkName: "pages/no-subscription" */))
const _3cee529b = () => interopDefault(import('../pages/redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _2e55f3d8 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _f74f94ba = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4cb76fba = () => interopDefault(import('../pages/_countryCode.vue' /* webpackChunkName: "pages/_countryCode" */))
const _1e94e866 = () => interopDefault(import('../pages/_countryCode/index.vue' /* webpackChunkName: "pages/_countryCode/index" */))
const _2a9df330 = () => interopDefault(import('../pages/_countryCode/_disciplineCode.vue' /* webpackChunkName: "pages/_countryCode/_disciplineCode" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/countries",
    component: _19a2bbf6,
    name: "countries"
  }, {
    path: "/help",
    component: _2115ca00,
    name: "help"
  }, {
    path: "/no-subscription",
    component: _e701308c,
    name: "no-subscription"
  }, {
    path: "/redirect",
    component: _3cee529b,
    name: "redirect"
  }, {
    path: "/terms",
    component: _2e55f3d8,
    name: "terms"
  }, {
    path: "/",
    component: _f74f94ba,
    name: "index"
  }, {
    path: "/:countryCode",
    component: _4cb76fba,
    children: [{
      path: "",
      component: _1e94e866,
      name: "countryCode"
    }, {
      path: ":disciplineCode",
      component: _2a9df330,
      name: "countryCode-disciplineCode"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
